module.exports = __webpack_public_path__ + "img/4.8265d676.png";